export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/crossover.b248fccd.svg","height":33,"width":87,"blurWidth":0,"blurHeight":0};